import { DEFAULT_LOCALE, isLocale } from './locales.js';
function parseAcceptLanguage(header) {
    const entries = header
        .split(',')
        .map((part) => {
        const trimmed = part.trim();
        if (!trimmed)
            return null;
        const [tagPart, ...paramParts] = trimmed.split(';');
        const primary = tagPart?.trim().split('-')[0]?.toLowerCase();
        if (!primary)
            return null;
        const qParam = paramParts.find((p) => p.trim().startsWith('q='));
        const quality = qParam ? Number.parseFloat(qParam.trim().slice(2)) : 1;
        return { tag: primary, quality: Number.isFinite(quality) ? quality : 0 };
    })
        .filter((entry) => entry !== null);
    return entries
        .sort((a, b) => b.quality - a.quality)
        .map((entry) => entry.tag)
        .filter(isLocale);
}
/**
 * The one negotiator (§20.5/§20.6), shared by the SSR landing and the
 * server (email locale). Detection order, first hit wins: explicit switcher
 * choice → `users.locale` → `/ro` route prefix → `Accept-Language` → `en`.
 */
export function negotiateLocale(input) {
    const directCandidates = [input.explicit, input.persisted, input.routePrefix];
    for (const candidate of directCandidates) {
        if (candidate && isLocale(candidate))
            return candidate;
    }
    if (input.acceptLanguage) {
        const [best] = parseAcceptLanguage(input.acceptLanguage);
        if (best)
            return best;
    }
    return DEFAULT_LOCALE;
}
